/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'

export const protobufPackage = 'Reality.Reality.Api'

export interface FurnitureGachaRarityEmissionRate {
  rarity: number
  emissionRate: number
}

function createBaseFurnitureGachaRarityEmissionRate(): FurnitureGachaRarityEmissionRate {
  return { rarity: 0, emissionRate: 0 }
}

export const FurnitureGachaRarityEmissionRate = {
  encode(
    message: FurnitureGachaRarityEmissionRate,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.rarity !== 0) {
      writer.uint32(8).int64(message.rarity)
    }
    if (message.emissionRate !== 0) {
      writer.uint32(17).double(message.emissionRate)
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): FurnitureGachaRarityEmissionRate {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFurnitureGachaRarityEmissionRate()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.rarity = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.emissionRate = reader.double()
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): FurnitureGachaRarityEmissionRate {
    return {
      rarity: isSet(object.rarity) ? Number(object.rarity) : 0,
      emissionRate: isSet(object.emissionRate)
        ? Number(object.emissionRate)
        : 0,
    }
  },

  toJSON(message: FurnitureGachaRarityEmissionRate): unknown {
    const obj: any = {}
    message.rarity !== undefined && (obj.rarity = Math.round(message.rarity))
    message.emissionRate !== undefined &&
      (obj.emissionRate = message.emissionRate)
    return obj
  },

  fromPartial<
    I extends Exact<DeepPartial<FurnitureGachaRarityEmissionRate>, I>
  >(object: I): FurnitureGachaRarityEmissionRate {
    const message = createBaseFurnitureGachaRarityEmissionRate()
    message.rarity = object.rarity ?? 0
    message.emissionRate = object.emissionRate ?? 0
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
